import { render, staticRenderFns } from "./PaymentsTypes.vue?vue&type=template&id=249c604f"
import script from "./PaymentsTypes.vue?vue&type=script&lang=js"
export * from "./PaymentsTypes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports